export default __webpack_public_path__ + "static/media/1790.354b0d74.png";